// extracted by mini-css-extract-plugin
export default {"container":"placeholder_container__DUo9w","icon":"placeholder_icon__g0CHU"};